module.exports = __webpack_public_path__ + "static/media/profile.a1715089.png";